import React, { Component, Fragment, useEffect, useState } from "react";
import {
    Row, Card,
    CardTitle, Label,
    Input, Button,
    FormGroup, Modal,
    ModalBody, InputGroup,
    InputGroupAddon,
    InputGroupText,
    Col,
    ModalHeader,
    ModalFooter,
} from 'reactstrap';
import { Colxx } from "../../../../../../../components/common/CustomBootstrap";
import { components } from "react-select";
import { Wizard, Steps, Step } from "react-albus";
import BottomNavigation from "../../../../../../../components/wizard/BottomNavigation";
import TopNavigation from "../../../../../../../components/wizard/TopNavigation";
import { postAPI_Invitation, postAPI_EmailCheck } from "../../../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../../../helpers/AxiosAPI";
import { default as ReactSelect } from "react-select";
import { NotificationManager } from "../../../../../../../components/common/react-notifications";
import Validation from "../../../../../../../components/Validation";

export default function SellVoucher({ toggle, isvisible, propertydata, userData, propertyId, voucherList, locale }) {
    const [widthDiv, setwidthDiv] = useState('95%');
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [bottomNavHidden, setBottomNavHidden] = useState(true);
    const [optionSelected, setOptionSelected] = useState([]);
    const [errorMsg, setErrorMsg] = useState(false);
    const [errorModel, setErrorModel] = useState(false);
    const [propertyData, setPropertyData] = useState(propertydata);
    const [typeofVoucher, setTypeofVoucher] = useState('Please Select');
    let [inviteeData, setInviteeData] = useState({
        "groupId": getGroupID(),
        "senderName": propertyData.name,
        "senderEmail": userData.email ? userData.email : '',
        "inviteeEmail": '',
        "senderGroupId": getGroupID(),
        "senderPropertyId": propertyId,
        "invitationStatus": 'Invited',
        "processingFee": '',
        "sellFutureVouchers": '',
        "status": 'Active',
        "createdBy": 'Admin',
        "type": 'Sell',
        'EmailType': '',
    });
    let options = [];
    const SendInviation = () => {
        if (!bottomNavHidden) {
            AxiosAPI({
                method: 'post',
                url: `${postAPI_EmailCheck}`,
                data: {
                    email: inviteeData.inviteeEmail,
                },
            })
                .then((res) => {
                    if (res.data.exists) {
                        inviteeData.EmailType = 'Multiple';
                    }
                    AxiosAPI({
                        url: `${postAPI_Invitation}`,
                        method: 'post',
                        data: inviteeData
                    }).then(res => {
                        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                            && res.data.Messages !== null && res.data.Messages.length > 0) {
                            setMsg(res.data.Messages);
                            setOpen(true);
                        }
                        else {
                            toggle();
                            if (res.data.status !== 'Failed') {
                                NotificationManager.success(
                                    "",
                                    "Invitation sent successfully",
                                    3000,
                                    null,
                                    null,
                                    "success"
                                );
                            } else {
                                NotificationManager.success(
                                    "",
                                    "Something went wrong",
                                    3000,
                                    null,
                                    null,
                                    "danger"
                                );
                            }
                        }
                    }).catch();
                })
                .catch((err) => null);
        }
    };
    const onClickNext = (goToNext, steps, step) => {
        if (step.id === 'step1')
            LoadData();

        if (step.id === 'step3') {
            if (inviteeData.processingFee === '') {

                setErrorModel(true);
                setErrorMsg('Please enter partner’s commission rate');
                return;
            }
        }
        if (step.id === 'step4') {
            if (inviteeData.inviteeEmail === '') {
                setErrorModel(true);
                setErrorMsg('Please enter the email address');
                return;
            }
        }
        if (steps.length - 1 <= steps.indexOf(step)) {
            return;
        }
        let list = [];
        if (step.id === 'step4') {
            setBottomNavHidden(false);
        }
        inviteeData.voucherList = list;
        setInviteeData({ ...inviteeData, sellFutureVouchers: (typeofVoucher === "All current & future vouchers" ? true : false) });
        goToNext();
    };
    const handleChange = async (selected) => {
        if (selected.length > 0) {
            selected.map((s) => {

                if (optionSelected.filter((f) => f.value === s.value).length > 0) {
                    let list = optionSelected.filter((f) => f.value !== s.value);
                    setOptionSelected(list);
                } else {
                    let list = optionSelected;
                    list.push({ value: s.value, label: s.label, isSelected: true });
                    setOptionSelected(list);
                }
            })
        } else {
            setOptionSelected([]);
        }
    };
    const onClickPrev = (goToPrev, steps, step) => {
        setwidthDiv('95%');
        if (steps.indexOf(step) <= 0) {
            return;
        }
        goToPrev();
    };
    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={optionSelected.filter((f) => f.value === props.value).length > 0 ? true : false}
                        onChange={() => setInviteeData({ ...inviteeData, voucherList: [] })}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };

    const LoadData = () => {
    };
    const handleDropDown = (e) => {
        setTypeofVoucher(e.target.value);
        if (e.target.value === 'All current & future vouchers')
            setInviteeData({ ...inviteeData, sellFutureVouchers: true });
        else
            setInviteeData({ ...inviteeData, sellFutureVouchers: false });

    }
    return (
        <Fragment>
            <Modal
                toggle={toggle}
                size="lg" isOpen={isvisible} style={{ maxWidth: '50%' }}>
                <ModalBody toggle={toggle}>
                    <Row className="h-100">
                        <Colxx xxs="12" className="mx-auto my-auto">
                            <Card className="auth-card">
                                <div
                                    className="form-side wizard wizard-default "
                                    style={{ padding: '20px', margin: 'auto', width: widthDiv }}
                                >
                                    <div className="text-center">
                                        <div className="d-flex my-1 justify-content-end">
                                            <p>  <span className="mb-3 justify-content-end" onClick={() => { SendInviation(); }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </span>
                                            </p>
                                        </div>


                                        <p className="mb-3 invite-title text-center">   <h3>Growing your <strong className="aiva-bold">aiva</strong> network! </h3>
                                        </p>

                                        {/* <p>
                                            Sign up and you will get an email within 24 hrs with your
                                            account information
                                        </p> */}

                                    </div>
                                    <Wizard className="text-center">
                                        <TopNavigation className="justify-content-center" disableNav />
                                        <Steps>
                                            <Step id="step1" name="Step 1" desc="Introduction">
                                                <FormGroup>
                                                    <CardTitle className="text-center">
                                                        <p className='my-2'>You’ve decided to tap into the  <strong className="aiva-bold">aiva</strong> network by inviting like minded businesses to sell their vouchers on your website... smart move! You’ll have a bigger range to offer your website visitors and in return you can offer commission to the partner business..
                                                        </p>
                                                        <p className='my-2'>Remember you are in total control of your sales channels. You can select which businesses you invite, which of their vouchers you would like to sell and the commission amount.</p>
                                                        <p className='voucher-preview my-2'><a target="blank" href='https://www.getaiva.com'> Learn more...</a></p>
                                                    </CardTitle>
                                                </FormGroup>
                                            </Step>

                                            <Step id="step3" className="text-center" name="Step 2" desc="Commission rate">
                                                <p className=" text-center my-2">
                                                    It’s time to select the commission rate (as a percentage) that you’ll offer your new <strong className="aiva-bold">aiva</strong> partner. This will apply to each voucher selected. Commission can be adjusted at any time.
                                                </p>
                                                <p className=" text-center my-2">
                                                    <strong>aiva</strong>’s processing fee is standard and includes the Stripe and merchant/credit card processing fees.
                                                </p>
                                                <p className=" text-center mt-2 mb-4">
                                                    <strong className="aiva-bold">Hint:</strong> If you want to offer different commission rates for different vouchers, you can either send separate requests to your new <strong className="aiva-bold">aiva</strong> partner, or adjust each voucher at a later time.
                                                </p>
                                                <Row className="text-center">
                                                    <Colxx sm={6} className="mb-3">
                                                        <FormGroup>
                                                            <Label className="mt-2">  <strong>aiva</strong> processing fee
                                                            </Label>
                                                            <InputGroup>
                                                                <Input
                                                                    type="number"
                                                                    name="bmbVoucherProcessingFee"
                                                                    id="bmbVoucherProcessingFee"
                                                                    disabled={true}
                                                                    value={propertyData.bmbVoucherProcessingFee}
                                                                />
                                                                <InputGroupAddon >
                                                                    <InputGroupText>%</InputGroupText>
                                                                </InputGroupAddon>
                                                            </InputGroup>

                                                        </FormGroup>
                                                    </Colxx>
                                                    <Colxx sm={6} className="mb-3">
                                                        <FormGroup>
                                                            <Label className="mt-2">Partner’s commission rate
                                                            </Label>
                                                            <InputGroup>
                                                                <Input
                                                                    type="number"
                                                                    name="processingFee"
                                                                    id="processingFee"
                                                                    value={inviteeData.processingFee}
                                                                    onChange={(e) => {
                                                                        setInviteeData({ ...inviteeData, processingFee: e.target.value });
                                                                    }}
                                                                />
                                                                <InputGroupAddon >
                                                                    <InputGroupText>%</InputGroupText>
                                                                </InputGroupAddon>
                                                                {/* <Tooltip>  </Tooltip> */}

                                                            </InputGroup>

                                                        </FormGroup>
                                                    </Colxx>
                                                </Row>
                                            </Step>

                                            <Step id="step4" name="Step 3" className="text-center" desc="Invite">
                                                <p className=" text-center  my-3">
                                                    You are nearly there! We just need to know who to send your invite to.</p>

                                                <Row className=" text-center invitation">
                                                    <Colxx sm={10} className="mx-auto">
                                                        <FormGroup className="d-flex invitation">
                                                            <span className="mt-2">I`m </span><span className="mt-2 mx-1">inviting</span>
                                                            <Input
                                                                type="text"
                                                                style={{ maxWidth: "50%" }}
                                                                name="inviteeEmail"
                                                                id="inviteeEmail"
                                                                placeholder='Their Email Address'
                                                                value={inviteeData.inviteeEmail}
                                                                onChange={(e) => {
                                                                    setInviteeData({ ...inviteeData, inviteeEmail: e.target.value });
                                                                }}
                                                            /> <span className="mt-2 ml-1">from {propertydata.name} business</span>
                                                        </FormGroup>
                                                    </Colxx>
                                                    {/* <Colxx sm={6} className="mx-auto mt-2">
                                                        <FormGroup>
                                                            <InputGroup>
                                                                <InputGroupAddon >
                                                                    <InputGroupText>To</InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input
                                                                    type="text"
                                                                    name="inviteeName"
                                                                    id="inviteeName"
                                                                    placeholder=''
                                                                    value={inviteeData.inviteeName}
                                                                    onChange={(e) => {
                                                                        setInviteeData({ ...inviteeData, inviteeName: e.target.value });
                                                                    }}
                                                                />
                                                            </InputGroup>

                                                        </FormGroup>
                                                    </Colxx>
                                                    <Colxx sm={6} className="mt-2">
                                                        <InputGroup>
                                                            <Input
                                                                type="textarea"
                                                                name="inviteeMessage"
                                                                id="inviteeMessage"
                                                                placeholder='Message'
                                                                style={{ height: '100px' }}
                                                                value={inviteeData.inviteeMessage}
                                                                onChange={(e) => {
                                                                    setInviteeData({ ...inviteeData, inviteeMessage: e.target.value });
                                                                }}
                                                            />
                                                        </InputGroup>
                                                    </Colxx> */}
                                                </Row>
                                            </Step>
                                            <Step id="step5" name="Step 4" desc="Magic!">
                                                <CardTitle >

                                                    <p className=" text-center ">  Wow, you’ve done it, you’ve reached out to a like-minded tourism business.  </p>
                                                    <p className=" text-center my-2">We’ll let you know once its approved and it will then feature on their website. OMG you will be one step closer to eternal happiness!
                                                    </p>
                                                </CardTitle>
                                                <Row className="row my-3 text-center">
                                                    <Colxx sm={12} className="text-center mb-3">
                                                        <Button color='primary' className='aiva-background' onClick={() => {  SendInviation(); }}>
                                                            Close
                                                        </Button>
                                                    </Colxx>
                                                </Row>
                                            </Step>
                                        </Steps>
                                        {bottomNavHidden && <BottomNavigation
                                            onClickNext={onClickNext}
                                            onClickPrev={onClickPrev}
                                            className={`mt-4 justify-content-center
                                                `}
                                            prevLabel="Back"
                                            check={true}
                                            nextLabel="Next"
                                        />}
                                    </Wizard>
                                    {/* <Row className="row my-3 ">
                                        <Colxx sm={12} className="text-right mb-3">
                                            <Button color="secondary" onClick={() => { toggle(); SendInviation(); }}>
                                                Close
                                            </Button>
                                        </Colxx>
                                    </Row> */}
                                </div>
                            </Card>
                        </Colxx>
                    </Row>
                </ModalBody>

            </Modal>
            <Modal isOpen={errorModel} toggle={() => setErrorModel(!errorModel)}>
                <ModalHeader>
                    Voucher Invitations
                </ModalHeader>
                <ModalBody>
                    <h3>{errorMsg}</h3>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => { setErrorModel(!errorModel); }}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment >
    );
}